import { DonationBackHeader } from '@web/components/page-components/DonationForm'
import DonationStepTabs from '@web/components/page-components/DonationForm/components/atoms/DonationStepTab'
import DonationAmountBanner from '@web/components/page-components/DonationForm/components/atoms/DonationAmountBanner'
import DonationFieldsForm from '../DonationFieldsForm'

const DonationFieldsStep = () => {
  return (
    <>
      <DonationStepTabs />
      <DonationAmountBanner />
      <DonationBackHeader title="Your Details" />
      <DonationFieldsForm />
    </>
  )
}

export default DonationFieldsStep
